// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserInfo } from 'models/user.model';
import moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { v1 as uuidV1 } from 'uuid';
import { USER_SERVICE, UserServiceInterface } from '../../../../../services/user.services';
import { LoadingComponent } from '../../../../_old_general-components/loading/loading.component';
import { DatePickerComponent } from '../../../fields/date-picker/date-picker.component';
import { SelectComponent } from '../../../fields/select/select.component';
import { TaskListItemComponent } from '../../../fields/task-list-item/task-list-item.component';
import { DynamicFormService } from '../../dynamic-form.service';
import { FormTemplateService } from '../form-template/form-template.service';
import { ParallelTaskService } from '../parallel-tasks/parallel-task.service';

@Component({
  selector: 'lbca-task-distribution',
  templateUrl: './task-distribution.component.html',
  styleUrls: ['./task-distribution.component.scss', '../sub-form/subform.component.scss'],
  imports: [SelectComponent, DatePickerComponent, LoadingComponent, TaskListItemComponent],
  providers: [ParallelTaskService],
})
export class TaskDistributionComponent implements OnInit {
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }
  @Input('error') set err(error) {
    this.error = error;
  }
  @Input('properties') set templateFields(properties) {
    this.recoveryResponsible = properties.recoveryResponsible;
    this.responsibleKey = properties.responsibleKey;

    this.template = properties.template;
    this.configuration = properties.configuration;
    this.context = properties.entityKey;
  }
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }
  @Input('dataAttr') set dataAttibutes(data) {
    this.atributesTask = data;
  }
  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
    if (this.recoveryResponsible) {
      this.dynamicFormService.formControlStructureChanged.subscribe((value) => {
        if (
          this.recoveryResponsible &&
          value.fieldControl[this.recoveryResponsible] &&
          value.fieldControl[this.recoveryResponsible]._value
        )
          if (this.preselectedUser != value.fieldControl[this.recoveryResponsible]._value) {
            this.preselectedUser = value.fieldControl[this.recoveryResponsible]._value;
            this.tasks.forEach((task) => {
              task['fields'][this.responsibleKey] = this.preselectedUser;
            });
            this.putTasks(this.tasks);
          }
      });
    }
  }
  @Input('origin') set disable(value) {
    if (value == 'task-form-complete') {
      this.disabled = true;
    }
  }

  @Input('externalData') set processData(data) {
    if (data && this.recoveryResponsible) {
      this.preselectedUser = data[this.recoveryResponsible];
    }
  }
  @Input('entityData') set modulesConfig(data) {
    if (data) {
      this.data = data;
      this.tasksForm = this.formBuilder.group({
        parent: [this.data.parent, [Validators.required]],
        date: [this.data.date, [Validators.required, Validators.min(1)]],
      });
      if (this.data.parent) {
        this.loading.push(true);
        if (this.disabled) {
          this.getBranchTasks();
        } else {
          this.getTasks();
        }
        this.getTaskTitles().subscribe(
          (resp: any) => {
            if (!resp) this.taskTitles = [];
            else {
              this.taskTitles = [...resp];
              this.taskTitles.forEach((item) => {
                item.label = item.description;
              });
            }
          },
          (error: any) => {
            this.errorApiEmmiter.emit(error);
          },
          () => {
            this.loading.pop();
          }
        );
      }
    } else {
      this.tasksForm = this.formBuilder.group({
        parent: [null, [Validators.required]],
        date: [null, [Validators.required, Validators.min(1)]],
      });
    }
  }
  @Output('errorApi') errorApiEmmiter = new EventEmitter();
  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();

  subFormModuleInstance: any;
  cardInfo!: any;
  error: any = {};
  template!: any;
  recoveryResponsible: any = null;
  responsibleKey: any = null;
  configuration!: any;
  tasksForm!: FormGroup;
  taskOptions: any[] = [];
  loading: boolean[] = [];
  taskTitles: any[] = [];
  tasks: any[] = [];
  flowId!: any;
  atributesTask!: any;
  context!: string;
  fieldOptions: any = {};
  data: any;
  preselectedUser: any;

  dateFields: any = {
    dateDue: 'sla_datedue_task',
    dateDueFatal: 'sla_datedue_fatal',
  };
  holidays: string[] = [
    '01/01',
    '15/04',
    '21/04',
    '01/05',
    '07/09',
    '12/10',
    '02/11',
    '15/11',
    '25/12',
  ];

  getUserData: UserInfo;
  dynamicFormService!: DynamicFormService;
  hasError = false;
  errors: any = {};
  disabled = false;

  validateCallback(event, i) {
    this.errors[i] = event;
  }

  ngOnInit(): void {
    this.getParentOptions('/task/drop-data', 'parallel_task_setup_types');
    this.validateCallbackEmitter.emit(this.validateCallbackFields);
    this.template.fields.forEach((field) => {
      if (field.auxEntity) {
        this.getDropdownData(field.auxEntity, field.entityKey);
      }
    });
  }

  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  constructor(
    private formBuilder: FormBuilder,
    private formTemplateService: FormTemplateService,
    private parallelTaskService: ParallelTaskService
  ) {
    this.getUserData = this.userService.getUserInfo() as any;
  }

  addTask() {
    const task = {
      fields: {},
      id: uuidV1(),
      selected: false,
      taskType: 'falange_tecnica',
      user: this.getUserData.fullname,
      min: this.tasksForm.controls['date'].value,
    };

    this.template.fields.forEach((item) => {
      task['fields'][item.entityKey] = null;
    });

    this.tasks.push(task);
  }

  generateTasks() {
    this.loading.push(true);
    this.getTaskTitles().subscribe(
      (resp: any) => {
        if (!resp) this.taskTitles = [];
        else {
          this.taskTitles = [...resp];
          this.tasks = [];
          this.taskTitles.forEach((item) => {
            const task = {
              managerReturn: item.managerReturn == 'true' || item.managerReturn == true,
              fields: {},
              id: uuidV1(),
              selected: false,
              taskAction_Phalange: item.id,
              taskType: item.taskType ?? 'falange_tecnica',
              user: this.getUserData.fullname,
              min: this.tasksForm.controls['date'].value,
            };

            item.label = item.description;

            this.template.fields.forEach((field) => {
              if (field.entityKey == 'dateDue' || field.entityKey == 'dateDueFatal') {
                const key = this.dateFields[field.entityKey];
                const dateFrom = this.tasksForm.controls['date'].value;
                let dateFinal = dateFrom + item[key] * 86400;
                let count = 0;
                while (
                  count < 14 &&
                  this.checkRulesDate(
                    moment(dateFinal * 1000),
                    field.rules,
                    field.disabledDateRules
                  ).error
                ) {
                  dateFinal += 86400;
                  count++;
                }
                task['fields'][field.entityKey] = dateFinal;
              } else {
                task['fields'][field.entityKey] = null;
              }

              if (field.entityKey == this.responsibleKey) {
                task['fields'][field.entityKey] = this.preselectedUser;
              }
            });

            this.tasks.push(task);
          });

          this.putTasks(this.tasks);
        }
      },
      (error: any) => {
        this.errorApiEmmiter.emit(error);
      },
      () => {
        this.loading.pop();
      }
    );
  }

  handleChangeValue(field, event) {
    this.tasksForm.controls[field].setValue(event);
    this.dynamicFormService.setTimeOutToSaveData(this.context, this.tasksForm.getRawValue());
  }

  handleTaskChange(value, id) {
    this.putTasks([value]);
  }

  putTasks(values: any[]) {
    const params = {
      context: this.context,
      processId: this.atributesTask.processNumber,
      taskId: this.cardInfo.id,
    };

    const tasks = values.map((value) => {
      const task = { ...value, ...value.fields };
      delete task.fields;
      delete task.min;
      // delete task.selected;
      Object.keys(task).forEach((key) => {
        if (task[key] == null) {
          delete task[key];
        }
      });
      return task;
    });

    this.parallelTaskService.postRequestTask(tasks, params).subscribe(
      (value) => {},
      (error) => {
        console.error(error);
      }
    );
  }

  getTasks() {
    const params = {
      context: this.context,
      processId: this.atributesTask.processNumber,
      taskId: this.cardInfo.id,
    };

    this.loading.push(true);

    this.formTemplateService.getDinamicUrl('/bpmn/parallel-requests-draft', params).subscribe(
      (resp: any) => {
        if (resp && resp.length > 0) {
          const tasks = resp;
          tasks.forEach((task) => {
            task['fields'] = {};
            this.template.fields.forEach((item) => {
              if (task[item.entityKey]) {
                task['fields'][item.entityKey] = task[item.entityKey];
                delete task[item.entityKey];
              } else {
                task['fields'][item.entityKey] = null;
              }
            });
            task['min'] = this.data.date;
          });

          this.tasks = tasks;
        }
      },
      (error: any) => {
        this.errorApiEmmiter.emit(error);
      },
      () => {
        this.loading.pop();
      }
    );
  }

  getBranchTasks() {
    const params = {
      context: this.context,
      processId: this.atributesTask.processNumber,
      taskId: this.cardInfo.id,
    };

    this.loading.push(true);

    this.formTemplateService.getDinamicUrl('/bpmn/parallel-requests-branches', params).subscribe(
      (resp: any) => {
        if (resp && resp.length > 0) {
          const tasks = resp;
          tasks.forEach((task) => {
            task['fields'] = {};
            this.template.fields.forEach((item) => {
              if (task[item.entityKey]) {
                task['fields'][item.entityKey] = task[item.entityKey];
                delete task[item.entityKey];
              } else {
                task['fields'][item.entityKey] = null;
              }
            });
            task['min'] = this.data.date;
          });

          this.tasks = tasks;
        }
      },
      (error: any) => {
        this.errorApiEmmiter.emit(error);
      },
      () => {
        this.loading.pop();
      }
    );
  }

  getParentOptions(entityUrl, tableName, params: any = {}) {
    params.tableName = tableName;
    params.flowId = this.flowId;
    this.loading.push(true);
    this.formTemplateService.getDinamicUrl(entityUrl, params).subscribe(
      (resp: any) => {
        if (!resp) this.taskOptions = [];
        else {
          this.taskOptions = [...resp];
        }
      },
      (error: any) => {
        this.errorApiEmmiter.emit(error);
      },
      () => this.loading.pop()
    );
  }

  getTaskTitles(): Observable<any> {
    const parent = this.tasksForm.controls['parent'].value;
    const initialDate = this.tasksForm.controls['date'].value;
    const params = {
      flowId: this.flowId,
      tableName: this.configuration?.actionCreate?.tableName ?? 'google-oficios',
      parent,
      initialDate,
    };

    return this.formTemplateService.getDinamicUrl('/task/drop-data-select-table', params);
  }

  deleteTasks() {
    const requests: any[] = [];
    this.loading.push(true);
    this.tasks.forEach((task) => {
      requests.push(this.parallelTaskService.delParallelRequest({ id: task.id }));
    });
    forkJoin(requests).subscribe(
      (response) => {
        this.tasks = [];
      },
      (error) => {
        console.error(error);
      },
      () => {
        this.loading.pop();
      }
    );
  }

  getDropdownData(auxEntity, entityKey) {
    const params = {
      flowId: this.flowId,
      tableName: auxEntity.tableName,
    };

    return this.formTemplateService.getDinamicUrl<any[]>(auxEntity.entityUrl, params).subscribe(
      (response: any[]) => {
        if (response.length > 0) {
          this.fieldOptions[entityKey] = response;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public validateCallbackFields = () => {
    let hasError = false;
    if (this.tasks.length > 0) {
      Object.keys(this.errors).forEach((error) => {
        if (this.errors[error]()) {
          hasError = true;
        }
      });
    }
    this.hasError = hasError;
    return this.hasError;
  };

  handleError(event, i) {
    this.errors[i] = event;
  }

  checkRulesDate(day: moment.Moment, rules, disabledDateRules) {
    const minValue = this.tasksForm.controls['date'].value;
    const maxValue = null;
    const today = moment().format('YYYY-MM-DD');
    const resp: any = { details: [], error: false, params: [] };
    try {
      resp.details = [];
      resp.error = false;

      if (Array.isArray(rules)) {
        rules.forEach((rule) => {
          switch (rule) {
            case 'du>=d':
              if (!moment(day).isAfter(today) && !moment(day).isSame(today)) {
                resp.details.push('A data informada deve ser igual ou maior que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du>d':
              if (!moment(day).isAfter(today)) {
                resp.details.push('A data informada deve ser maior que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du<=d':
              if (!moment(day).isBefore(today) && !moment(day).isSame(today)) {
                resp.details.push('A data informada deve ser igual ou menor que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du<d':
              if (!moment(day).isBefore(today)) {
                resp.details.push('A data informada deve ser menor que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du>=mn':
              if (
                minValue &&
                !moment(day).isAfter(moment.unix(minValue)) &&
                !moment(day).isSame(moment.unix(minValue))
              ) {
                resp.details.push('A data informada deve ser igual ou maior que a data mínima');
                resp.error = true;
              }
              break;
            case 'du>mn':
              if (!moment(day).isAfter(moment.unix(minValue))) {
                resp.details.push('A data informada deve ser maior que a data mínima');
                resp.error = true;
              }
              break;
            case 'du<=mx':
              if (
                maxValue &&
                !moment(day).isBefore(moment.unix(maxValue)) &&
                !moment(day).isSame(moment.unix(maxValue))
              ) {
                resp.details.push('A data informada deve ser igual ou menor que a data máxima');
                resp.error = true;
              }
              break;
            case 'du<mx':
              if (maxValue && !moment(day).isBefore(moment.unix(maxValue))) {
                resp.details.push('A data informada deve ser menor que a data máxima');
                resp.error = true;
              }
              break;
            default:
              console.warn('invalid rule');
          }
        });
      }

      if (Array.isArray(disabledDateRules)) {
        disabledDateRules.forEach((disabledDateRule) => {
          let applyRule = false;
          const { conditions = {} } = disabledDateRule;

          const ops = {
            gte: (value) => moment().isSameOrAfter(value),
            gt: (value) => moment().isAfter(value),
            lte: (value) => moment().isSameOrBefore(value),
            lt: (value) => moment().isBefore(value),
          };

          const types = {
            time: (op, value) => ops[op](moment(value, 'hh:mm')),
          };

          if (Array.isArray(conditions?.or)) {
            const orRulesSatisfied = conditions.or.filter((orRule) =>
              types[orRule.type](orRule.op, orRule[orRule.type])
            );
            applyRule = orRulesSatisfied.length === conditions.or.length;
          }

          if (Array.isArray(conditions?.and)) {
            const andRulesSatisfied = conditions.and.filter((andRule) =>
              types[andRule.type](andRule.op, andRule[andRule.type])
            );
            applyRule = andRulesSatisfied.length === conditions.and.length;
          }

          if (conditions?.always) applyRule = true;

          if (applyRule) {
            switch (disabledDateRule.rule) {
              case 'sunday':
                if (day.isoWeekday() === 7) {
                  resp.details.push('A data informada não pode ser um domingo');
                  resp.error = true;
                }
                break;
              case 'saturday':
                if (day.isoWeekday() === 6) {
                  resp.details.push('A data informada não pode ser um sábado');
                  resp.error = true;
                }
                break;
              case 'holidays':
                if (this.holidays.includes(day.format('DD/MM'))) {
                  resp.details.push('A data informada não pode ser um feriado nacional');
                  resp.error = true;
                }
                break;
              case 'nextBusinessday':
                // eslint-disable-next-line no-case-declarations
                let current = moment(day.format('DDMMYYYY'), 'DDMMYYYY');
                for (let index = 0; index < disabledDateRule.quantity || index > 100; ) {
                  current = current.subtract(1, 'days');
                  if (
                    !(
                      current.isoWeekday() === 7 ||
                      current.isoWeekday() === 6 ||
                      this.holidays.includes(current.format('DD/MM'))
                    )
                  ) {
                    index++;
                  }
                }

                if (moment(current).isBefore(today) || moment(current).isSame(today)) {
                  resp.details.push(
                    `A data informada deve ser posterior ao(s) próximo(s) ${disabledDateRule.quantity} dia(s) útil(eis)`
                  );
                  resp.error = true;
                }
                break;
              case 'lt':
                if (day.isBefore(moment().startOf('day'))) {
                  resp.details.push('A data informada deve ser posterior a data atual');
                  resp.error = true;
                }
                break;
              case 'lte':
                if (day.isSameOrBefore(moment().endOf('day'))) {
                  resp.details.push('A data informada deve ser posterior ou igual a data atual');
                  resp.error = true;
                }
                break;
              case 'gt':
                if (day.isAfter(moment().endOf('day'))) {
                  resp.details.push('A data informada deve ser anterior a data atual');
                  resp.error = true;
                }
                break;
              case 'gte':
                if (day.isSameOrAfter(moment().startOf('day'))) {
                  resp.details.push('A data informada deve ser anterior ou igual a data atual');
                  resp.error = true;
                }
                break;
              case 'ltmn':
                if (minValue && day.isBefore(moment.unix(minValue).startOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser posterior ou igual a ' +
                      moment.unix(minValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              case 'ltemn':
                if (minValue && day.isSameOrBefore(moment.unix(minValue).endOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser posterior a ' + moment.unix(minValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              case 'gtmx':
                if (maxValue && day.isAfter(moment.unix(maxValue).endOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser anterior ou igual a ' +
                      moment.unix(maxValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              case 'gtemx':
                if (maxValue && day.isSameOrAfter(moment.unix(maxValue).startOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser anterior a ' + moment.unix(maxValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              default:
                console.warn('invalid rule');
            }
          }
        });
      }
    } catch (e) {
      resp.details = ['Não há regras de data'];
      resp.error = false;
    }
    return resp;
  }
}
